import { useCallback } from 'react'
import {
  useFlag,
  useUnleashClient,
  useUnleashContext,
  useVariant
} from '@unleash/proxy-client-react'
import { CurrentUser } from 'customTypes'
import { buildContext } from './unleash'

export enum Feature {
  AvailabilityCaching = 'availability_caching_web_members',
  CompoundedSemaglutideNewCoupon = 'compounded_semaglutide_new_coupon_web_members',
  DexcomG6ByosRealtimeApi = 'dexcom_g6_byos_realtime_api_web_members',
  DexcomG7ByosRealtimeApi = 'dexcom_g7_byos_realtime_api_web_members',
  Experiment4MonthProduct = 'experiment_4_month_product_web_members',
  ExperimentVideoCallFirstCallSchedulingWindow = 'experiment_video_call_first_call_scheduling_window_web_members',
  IneligibleCallUpsell = 'ineligible_call_upsell_web_members',
  InsuranceBenefitsCheck = 'insurance_benefits_check_web_members',
  MedicalRescheduleCancel = 'medical_reschedule_cancel_web_members',
  PotentiallyRecurringSlots = 'potentially_recurring_slots_web_members',
  PremiumUpgrade = 'premium_upgrade_web_members',
  RDWelcomeVideo = 'rd_welcome_video_web_members',
  RecurringAppointmentsScheduling = 'recurring_appointments_scheduling_web_members',
  StressManagementMnt = 'stress_management_mnt_web_members',
  LabPanelsUpsell = 'lab_panels_upsell_web_members',
  LibreLinkupRemoval = 'libre_linkup_removal_web_members',
  MicrobiomeUpsell = 'microbiome_upsell_web_members',
  VideoCallsDashboard = 'video_calls_dashboard_web_members',
  VideoCallsFiltering = 'video_calls_filtering_web_members',
  VideoCallsPhoneNumber = 'video_calls_phone_number_web_members',
  VideoCallsSecondaryHealthGoal = 'video_calls_secondary_health_goal_web_members',
  VideoCallsSpecialtiesFiltering = 'video_calls_specialties_filtering_web_members',
  VideoCallsTimeFiltering = 'video_calls_time_filtering_web_members',
  VideoCallsUnavailableSlotsBooking = 'video_calls_unavailable_slots_booking_web_members',
  VideoCallsUnavailableSlotsBookingByDefault = 'video_calls_unavailable_slots_booking_by_default_web_members',
  OwnSensorV2ExpressCheckout = 'own_sensor_v2_express_checkout_web_members',
  DexcomHideWebUpsells = 'dexcom_hide_web_upsells_web_members',
  DexcomSkipCreditCard = 'dexcom_skip_credit_card_web_members',
  DexcomSchedulerAtBeginning = 'dexcom_scheduler_at_beginning_web_members',
  UnifiedAppointmentBookingFlow = 'unified_appointment_booking_flow_web_members'
}

export const useFeatureFlag = (feature: Feature): boolean => {
  return useFlag(feature)
}

export const useIsFeatureEnabled = () => {
  const unleashClient = useUnleashClient()
  return useCallback(
    (feature: Feature) => {
      return unleashClient.isEnabled(feature)
    },
    [unleashClient]
  )
}

export const useSetFeatureContext = () => {
  const updateContext = useUnleashContext()
  return useCallback(
    async (user: Pick<NonNullable<CurrentUser>, 'id' | 'email'>) => {
      const context = buildContext(user.id, user.email)
      await updateContext(context)
    },
    [updateContext]
  )
}

export const useFeatureFlagVariantPayload = (feature: Feature) => {
  const variant = useVariant(feature)
  return variant.payload?.value
}
